import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Separator } from '../ui/separator';
import { Badge } from '../ui/badge';

const ComplianceTab = ({ formData, updateDeskField, masterData, readOnly = false }) => {
  const data = formData.compliance || {};
  const update = (field, value) => {
    if (readOnly) return;
    updateDeskField('compliance', field, value);
  };
  const users = masterData.users || [];

  const renderUserOptions = () => users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-primary">Compliance Details</CardTitle>
        <CardDescription>
          Credibility interview and compliance checks
          {readOnly && <Badge variant="outline" className="ml-2">View Only - You don't have permission to edit this desk</Badge>}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Compliance Officer</Label>
            <Select value={data.compliance_officer || 'none'} onValueChange={(v) => update('compliance_officer', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                {renderUserOptions()}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Compliance Manager</Label>
            <Select value={data.compliance_manager || 'none'} onValueChange={(v) => update('compliance_manager', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                {renderUserOptions()}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Interview Proceeding</Label>
            <Select value={data.interview_proceeding || 'none'} onValueChange={(v) => update('interview_proceeding', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                <SelectItem value="not_required">Not Required</SelectItem>
                <SelectItem value="scheduled">Scheduled</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <Separator />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Credibility Interview Result</Label>
            <Select value={data.interview_result || 'none'} onValueChange={(v) => update('interview_result', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger data-testid="compliance-outcome"><SelectValue placeholder="Select outcome" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="passed">Passed</SelectItem>
                <SelectItem value="failed">Failed</SelectItem>
                <SelectItem value="rescheduled">Rescheduled</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Credibility Interview Scheduled</Label>
            <Input type="datetime-local" value={data.interview_scheduled || ''} onChange={(e) => update('interview_scheduled', e.target.value)} data-testid="compliance-interview-date" readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label>Student Skype ID</Label>
            <Input value={data.student_skype || ''} onChange={(e) => update('student_skype', e.target.value)} readOnly={readOnly} />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Credibility Interview Booking Date</Label>
            <Input type="date" value={data.interview_booking_date || ''} onChange={(e) => update('interview_booking_date', e.target.value)} readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label>University Interview Status</Label>
            <Select value={data.university_interview_status || 'none'} onValueChange={(v) => update('university_interview_status', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                <SelectItem value="not_required">Not Required</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="scheduled">Scheduled</SelectItem>
                <SelectItem value="passed">Passed</SelectItem>
                <SelectItem value="failed">Failed</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>2nd Interview Date (If Failed)</Label>
            <Input type="date" value={data.second_interview_date || ''} onChange={(e) => update('second_interview_date', e.target.value)} readOnly={readOnly} />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Compliance Information Notes</Label>
          <Textarea value={data.notes || ''} onChange={(e) => update('notes', e.target.value)} placeholder="Add any compliance notes..." rows={4} data-testid="compliance-notes" readOnly={readOnly} />
        </div>
      </CardContent>
    </Card>
  );
};

export default ComplianceTab;
